import Api from "./base/api-base";

export default class ConstructionDateApi {

  info(date, department_id) {
    return Api.link.get({
      links: [
        {endpoint: Api.endpoint.construction, id: date},
        {endpoint: Api.endpoint.department, id: department_id}
      ]
    });
  }
}
